export enum FollowUpStudyDisplayStatus {
	Draft = "draft",
	Returned = "returned",
	Submitted = "submitted",
}
